const route = {
	path: '/accouting-diccionary',
	name: 'accouting-diccionary',
	meta: {
		title: 'Diccionario Ats',
	},
	component: () => import('@/pages/atsDictionary/ats-modules'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/ats-dictionary.js